import { render, staticRenderFns } from "./TaskEditDialog.vue?vue&type=template&id=6655d8a7&scoped=true"
import script from "./TaskEditDialog.vue?vue&type=script&lang=ts"
export * from "./TaskEditDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6655d8a7",
  null
  
)

export default component.exports